import { motion } from "framer-motion";

export const PageHero = ({ overline, title, emphasis, subtitle }) => (
  <section className="bg-[#050505] text-white pt-40 pb-20 md:pt-48 md:pb-28 px-6" data-testid="page-hero">
    <div className="max-w-7xl mx-auto">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }} className="flex items-center gap-3 mb-8">
        <span className="h-px w-10 bg-white/30" />
        <span className="text-xs uppercase tracking-[0.24em]" style={{ color: "var(--gold)" }}>{overline}</span>
      </motion.div>
      <div className="overflow-hidden">
        <motion.h1 initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="text-5xl sm:text-6xl md:text-7xl tracking-tightest leading-[0.95] font-semibold max-w-4xl">
          {title} <span className="font-serif-italic font-normal" style={{ color: "var(--gold)" }}>{emphasis}</span>
        </motion.h1>
      </div>
      {subtitle && (
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4, duration: 0.8 }}
          className="mt-8 text-lg md:text-xl text-white/55 max-w-2xl leading-relaxed">{subtitle}</motion.p>
      )}
    </div>
  </section>
);
